import type { MetricResult, TableColumn } from '../types';

type BackendTableColumn = {
  key: string;
  header?: string;
  label?: string;
  type?: string;
};

type BackendMetricResult = Omit<MetricResult, 'table'> & {
  table?: {
    columns: BackendTableColumn[];
    rows: Record<string, unknown>[];
  };
};

const mapColumnType = (type?: string): TableColumn['type'] => {
  switch (type) {
    case 'percent':
      return 'percent';
    case 'trendArrow':
    case 'trend':
      return 'trend';
    case 'badge':
    case 'deltaBadge':
      return 'badge';
    case 'bar':
      return 'bar';
    case 'number':
      return 'number';
    case 'text':
    default:
      return 'text';
  }
};

/** Normalize backend MetricResult (e.g. table.header) into UI MetricResult. */
export const adaptMetricResult = (raw: BackendMetricResult): MetricResult => {
  if (!raw.table) {
    return raw as MetricResult;
  }

  return {
    ...raw,
    table: {
      columns: raw.table.columns.map(col => ({
        key: col.key,
        label: col.label ?? col.header ?? col.key,
        type: mapColumnType(col.type),
      })),
      rows: raw.table.rows,
    },
  };
};
